import {
  DeleteOutlined,
  EditOutlined,
  FolderAddOutlined,
} from "@ant-design/icons";
import { Table, Space, Tooltip, Pagination, Popover } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DeleteDesignationApi from "../../api/DeleteDesignationApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import { permissionAbility } from "../../helpers/permissionHelpers";
import ConfirmationModal from "../modal/ConfirmationModal";
import EditDesignationModal from "../modal/edit/EditDesignationModal";

function DesignationsTable(props) {
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const [page, setPage] = useState(1);
  const [editDesignation, setEditDesignation] = useState();
  const [deleteDesignationId, setDeleteDesignationId] = useState("");
  const [loading, setLoading] = useState(true);
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;
  
  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  /*If page changed from parent component */
  useEffect(() => {
    setPage(props.page);
  }, [props.page]);

  async function deleteDesignation() {
    const apiResponse = await DeleteDesignationApi(deleteDesignationId);
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Designation deleted");
      if (props.data?.designations?.length === 1) {
        props.changePage(page - 1);
      } else {
        props.changePage(page);
      }
    } else {
      openNotificationError("bottomRight", "Couldn't delete. Try again later.");
    }
    setDeleteDesignationId("");
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <div>{record.name}</div>,
    },
    {
      title: "Abbreviation",
      dataIndex: "abbreviation",
      key: "abb",
      render: (text, record) => <div>{record.abbreviation}</div>,
    },
    {
      title: "Positions",
      dataIndex: "positionsCount",
      key: "positionsCount",
      render: (text, record) => <div>{record.positionsCount || 0}</div>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          {permissionAbility(userLevel, "designations", "edit") && (
            <Tooltip title={"Edit"}>
              <div
                onClick={() => {
                  setEditModal(true);
                  setEditDesignation(record);
                }}
                className="text-blue-500 hover:text-blue-600 cursor-pointer"
              >
                <EditOutlined />
              </div>
            </Tooltip>
          )}
          {permissionAbility(userLevel, "designations", "delete") &&
            (record.canDelete ? (
              <Tooltip title={"Delete"}>
                <div
                  onClick={() => {
                    setDeleteModal(true);
                    setDeleteDesignationId(record.id);
                  }}
                  className="text-red-500 hover:text-red-600 cursor-pointer"
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            ) : record.canArchive ? (
              <Tooltip title={"Archive"}>
                <div
                  onClick={() => {
                    setArchiveModal(true);
                    setDeleteDesignationId(record.id);
                  }}
                  className="text-red-500 hover:text-red-600 cursor-pointer"
                >
                  <FolderAddOutlined />
                </div>
              </Tooltip>
            ) : (
              <Popover
                placement="left"
                content={"There are positions in this designation"}
                trigger="hover"
              >
                <div className="text-gray-500">
                  <FolderAddOutlined />
                </div>
              </Popover>
            ))}
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={props.data?.designations}
        loading={loading}
        pagination={false}
      />
      <div className="text-center mt-6">
        <Pagination
          onChange={(num) => props.changePage(num)}
          current={page}
          total={props.data?.totalCount || 0}
          pageSize={props.data?.limit}
        />
      </div>
      <ConfirmationModal
        visible={deleteModal}
        handleCancel={() => {
          setDeleteModal(false);
          setDeleteDesignationId("");
        }}
        handleOk={() => deleteDesignation()}
        text="Are you sure want to delete this designation?"
        title="Delete designation"
      />
      <ConfirmationModal
        visible={archiveModal}
        handleCancel={() => {
          setArchiveModal(false);
          setDeleteDesignationId("");
        }}
        handleOk={() => deleteDesignation()}
        text="Are you sure want to archive this designation?"
        title="Archive designation"
      />
      <EditDesignationModal
        visible={editModal}
        handleCancel={() => {
          setEditModal(false);
          setEditDesignation();
        }}
        designation={editDesignation}
        handleOk={() => props.changePage(page)}
      />
    </>
  );
}

export default DesignationsTable;
